export const isChartKey = (chartKey: number | null | undefined) =>
    chartKey !== 0 && chartKey !== undefined && chartKey !== null;
